<div class="tisco-modal-waiting" *ngIf="loadding">
    <div class="uk-position-center">
        <div class="uk-padding-small uk-border-rounded">
            <span class="+tisco-text-white" uk-spinner="ratio: 4.5"></span>
        </div>
    </div>
</div>